module.exports = __webpack_public_path__ + "static/media/wp_5.efb98941.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wp_5.png
// module id = 34
// module chunks = 0